export default {
  name: {
    labelId: ['fio', 'org.full-name'],
    placeholderId: ['fio', 'org.full-name'],
  },
  ogrnip: {
    labelId: 'ogrnip',
    placeholder: '123456789123456',
  },
  inn: {
    labelId: 'inn',
    placeholder: '123456789123',
  },
  address: {
    type: 'textarea',
    labelId: ['address.reg-ip', 'address.leg', 'address.reg-se'],
    placeholderId: ['address.reg-ip', 'address.leg', 'address.reg-se'],
  },
  actual_address: {
    type: 'textarea',
    labelId: ['address.act', 'address.act-se'],
    placeholderId: ['address.act', 'address.act-se'],
  },
  phone: {
    labelId: 'phone',
    placeholder: '+71234567890',
  },
  email: {
    labelId: 'address.email',
    placeholder: 'primer@primer.ru',
  },
  bank_name: {
    labelId: 'bank.name',
    placeholderId: 'bank.name',
  },
  bank_account: {
    labelId: 'acc.settl',
    placeholder: '40802810412345678912',
  },
  bik: {
    labelId: 'bic',
    placeholder: '044030811',
  },
  corr_account: {
    labelId: 'acc.corr',
    placeholder: '30101810030000000081',
  },
  // доп поля для ООО
  owner: {
    labelId: 'fio.gen-dir',
    placeholderId: 'fio.gen-dir',
  },
  ogrn: {
    labelId: 'ogrn',
    placeholder: '1234567891234',
  },
  kpp: {
    labelId: 'kpp',
    placeholder: '123456789',
  },
  contact_name: {
    labelId: 'fio.person',
    placeholderId: 'fio.person',
  },
  edo_id: {
    labelId: 'edo.id',
    placeholder: '2BM-1111111111-1111111111-11111111111111111111'
  },
  // поля для самозанятых
  birthday: {
    type: 'date',
    labelId: 'birthday',
  },
  document_serial: { labelId: 'document_serial', placeholder: '4021' },
  document_number: { labelId: 'document_number', placeholder: '123456' },
  document_unit_name: { labelId: 'document_unit_name', placeholder: 'ТП №899 по г. Москве' },
  document_unit_code: { labelId: 'document_unit_code', placeholder: '000-111' },
  document_date: { type: 'date', labelId: 'document_date' },
};
